import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { REGION_META, REGION_SELECT_OPTIONS } from "./constants";

const DAYS = Array.from({ length: 31 }, (_, i) => i + 1);
const MONTHS = Array.from({ length: 12 }, (_, i) => i + 1);

export default function LotterySearchForm({
  date,
  provincesByRegion,
  regions,
  onSearchMien,
  onSearchTinh,
}) {
  const parsed = dayjs(date);
  const years = useMemo(() => {
    const current = dayjs().year();
    return Array.from({ length: current - 2004 }, (_, i) => current - i);
  }, []);

  const regionOptions = useMemo(() => {
    if (!regions?.length) return REGION_SELECT_OPTIONS;
    return REGION_SELECT_OPTIONS.filter((opt) => regions.includes(opt.value));
  }, [regions]);

  const [mode, setMode] = useState("mien");
  const [mien, setMien] = useState(regionOptions[0]?.value || "MN");
  const [tinh, setTinh] = useState("");
  const [day, setDay] = useState(parsed.date());
  const [month, setMonth] = useState(parsed.month() + 1);
  const [year, setYear] = useState(parsed.year());

  useEffect(() => {
    const next = dayjs(date);
    if (!next.isValid()) return;
    setDay(next.date());
    setMonth(next.month() + 1);
    setYear(next.year());
  }, [date]);

  useEffect(() => {
    if (!regionOptions.some((opt) => opt.value === mien)) {
      setMien(regionOptions[0]?.value || "MN");
    }
  }, [regionOptions, mien]);

  const allProvinces = useMemo(() => {
    const groups = [
      { region: "MN", items: provincesByRegion?.MN || [] },
      { region: "MT", items: provincesByRegion?.MT || [] },
      { region: "MB", items: provincesByRegion?.MB || [] },
    ];
    if (!regions?.length) return groups;
    return groups.filter((group) => regions.includes(group.region));
  }, [provincesByRegion, regions]);

  useEffect(() => {
    if (tinh) return;
    const first = allProvinces.flatMap((g) => g.items)[0];
    if (first) setTinh(first.code);
  }, [allProvinces, tinh]);

  const buildDate = () => {
    const base = dayjs(`${year}-${String(month).padStart(2, "0")}-01`);
    const clamped = Math.min(day, base.daysInMonth());
    return base.date(clamped).format("YYYY-MM-DD");
  };

  const submit = (e) => {
    e.preventDefault();
    const nextDate = buildDate();
    if (mode === "mien") {
      onSearchMien({ region: mien, date: nextDate });
      return;
    }
    const found = allProvinces.flatMap((g) => g.items).find((p) => p.code === tinh);
    onSearchTinh({ province: tinh, region: found?.region, date: nextDate, name: found?.name });
  };

  return (
    <div className="xoso-box xoso-search">
      <h2 className="xoso-search__title">Tra Cứu Kết Quả Xổ Số</h2>
      <div className="xoso-search__toggle">
        <label className="xoso-search__radio">
          <input
            type="radio"
            name="xoso-search-mode"
            checked={mode === "mien"}
            onChange={() => setMode("mien")}
          />
          Miền
        </label>
        <label className="xoso-search__radio">
          <input
            type="radio"
            name="xoso-search-mode"
            checked={mode === "tinh"}
            onChange={() => setMode("tinh")}
          />
          Tỉnh
        </label>
      </div>

      <form onSubmit={submit}>
        {mode === "mien" ? (
          regionOptions.length > 1 ? (
            <div className="xoso-search__row">
              <select value={mien} onChange={(e) => setMien(e.target.value)}>
                {regionOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          ) : null
        ) : (
          <div className="xoso-search__row">
            <select value={tinh} onChange={(e) => setTinh(e.target.value)}>
              {allProvinces.map((group) => (
                <optgroup key={group.region} label={REGION_META[group.region].label}>
                  {group.items.map((p) => (
                    <option key={p.code} value={p.code}>
                      {p.name}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>
        )}

        <div className="xoso-search__row xoso-search__row--split">
          <select value={day} onChange={(e) => setDay(Number(e.target.value))}>
            {DAYS.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
          <select value={month} onChange={(e) => setMonth(Number(e.target.value))}>
            {MONTHS.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
          <select value={year} onChange={(e) => setYear(Number(e.target.value))}>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="xoso-search__cta">
          Xem kết quả
        </button>
      </form>
    </div>
  );
}
